import { Injectable, Logger, OnApplicationBootstrap } from '@nestjs/common';
import { Cron, CronExpression } from '@nestjs/schedule';
import { CustomerDBStatus, GiganetCustomerData } from '@ip6m/types';
import { environment } from '../environments/environment';

var Client = require('pg-native');
@Injectable()
export class PgService implements OnApplicationBootstrap {
    
    pgClient = new Client();
    isConnected: boolean = false;
    custNum: number = 0;
    dbHost: string = environment.database.host;

    queryAll = `(SELECT
      j_szolg.id AS "szolg_id",
      j_ugyfel.id AS "ugyfel_id",
      j_ugyfel.nev AS "ugyfel_nev",
      j_cim_telepules.irsz AS "irsz",
      j_cim_telepules.nev AS "telepulesnev",
      j_cim_telepules.varosresz AS "varosresz",
      j_cim_kozter_nevek.nev AS "kozternev",
      j_cim_kozter_jellegek.nev AS "kozterjelleg",
      j_internet_szolg.hsz AS "hazszam",
      j_internet_szolg.hsz2 AS "hazszam2",
      j_internet_szolg.gps_eszak AS "szolg_gps_latitude",
      j_internet_szolg.gps_kelet AS "szolg_gps_longitude",
      '0' AS "dist_box",
      j_device.serial_number AS "gpon_serial"
      FROM j_device
      INNER JOIN j_device_status_entry ON j_device.id = j_device_status_entry.device_id
      INNER JOIN j_device_status ON j_device_status_entry.status_id = j_device_status.id
      INNER JOIN j_device_on_service ON j_device_status_entry.id = j_device_on_service.status_entry_id
      INNER JOIN j_szolg ON j_device_on_service.service_id = j_szolg.id
      INNER JOIN j_ugyfel ON j_szolg.ugyfel_id = j_ugyfel.id
      INNER JOIN j_internet_szolg ON j_szolg.internet_szolg_id = j_internet_szolg.id
      INNER JOIN j_cim_osszerendelo ON j_cim_osszerendelo.id=j_internet_szolg.cim_osszerendelo_id
      INNER JOIN j_cim_telepules ON j_cim_telepules.id=j_cim_osszerendelo.telepules_id
      INNER JOIN j_cim_kozter_nevek ON j_cim_kozter_nevek.id=j_cim_osszerendelo.kozter_id
      INNER JOIN j_cim_kozter_jellegek ON j_cim_kozter_jellegek.id=j_cim_osszerendelo.kozter_jelleg_id
      WHERE j_device_status.name = 'szolgáltatásnál'
      Order by j_device_status_entry.id DESC
      Limit 1)
      UNION
      (SELECT
      0 AS "szolg_id",
      0 AS "ugyfel_id",
      j_ap_station.nev AS "ugyfel_nev",
      j_cim_telepules.irsz AS "irsz",
      j_cim_telepules.nev AS "telepulesnev",
      j_cim_telepules.varosresz AS "varosresz",
      j_cim_kozter_nevek.nev AS "kozternev",
      j_cim_kozter_jellegek.nev AS "kozterjelleg",
      j_ap_station.house_number AS "hazszam",
      j_ap_station.house_number_ext AS "hazszam2",
      j_ap_station.gps_eszak AS "szolg_gps_latitude",
      j_ap_station.gps_kelet AS "szolg_gps_longitude",
      '0' AS "dist_box",
      j_device.serial_number AS "gpon_serial"
      FROM j_device
      INNER JOIN j_device_status_entry ON j_device.id = j_device_status_entry.device_id																			  
      INNER JOIN j_device_on_base_station ON j_device_status_entry.id = j_device_on_base_station.status_entry_id
      INNER JOIN j_device_type ON j_device.type_id = j_device_type.id
      INNER JOIN j_device_designation ON j_device_type.designation_id = j_device_designation.id
      INNER JOIN j_ap_station ON j_device_on_base_station.base_station_id = j_ap_station.id
      INNER JOIN j_cim_osszerendelo ON j_cim_osszerendelo.id=j_ap_station.address_id
      INNER JOIN j_cim_telepules ON j_cim_telepules.id=j_cim_osszerendelo.telepules_id
      INNER JOIN j_cim_kozter_nevek ON j_cim_kozter_nevek.id=j_cim_osszerendelo.kozter_id
      INNER JOIN j_cim_kozter_jellegek ON j_cim_kozter_jellegek.id=j_cim_osszerendelo.kozter_jelleg_id
      WHERE (
      SELECT j_device_status.name FROM j_device_status_entry
      INNER JOIN j_device_status ON j_device_status.id = j_device_status_entry.status_id
      WHERE device_id = j_device.id
      ORDER BY j_device_status_entry.id DESC
      LIMIT 1
      )= 'bázisállomáson'
      AND j_device_designation.name = 'GPON ONU')
      UNION
      SELECT
      j_szolg.id AS "szolg_id",
      j_ugyfel.id AS "ugyfel_id",
      j_ugyfel.nev AS "ugyfel_nev",
      j_cim_telepules.irsz AS "irsz",
      j_cim_telepules.nev AS "telepulesnev",
      j_cim_telepules.varosresz AS "varosresz",
      j_cim_kozter_nevek.nev AS "kozternev",
      j_cim_kozter_jellegek.nev AS "kozterjelleg",
      j_internet_szolg.hsz AS "hazszam",
      j_internet_szolg.hsz2 AS "hazszam2",
      j_internet_szolg.gps_eszak AS "szolg_gps_latitude",
      j_internet_szolg.gps_kelet AS "szolg_gps_longitude",
      j_dm_gpon_dist_box.identifier AS "dist_box",
      j_dm_gpon_onu.gpon_serial AS "gpon_serial"
      FROM j_szolg
      INNER JOIN j_ugyfel ON j_ugyfel.id = j_szolg.ugyfel_id
      INNER JOIN j_internet_szolg ON j_internet_szolg.id = j_szolg.internet_szolg_id
      INNER JOIN j_szolg_csomag ON j_szolg_csomag.id = j_szolg.csomag_id
      INNER JOIN j_szolg_tipus ON j_szolg_tipus.id = j_szolg_csomag.tipus_id
      INNER JOIN j_status ON j_status.id = j_szolg.status_id
      INNER JOIN j_dm_gpon_onu ON j_dm_gpon_onu.id = j_internet_szolg.onu_id
      INNER JOIN j_dm_gpon_dist_box ON j_dm_gpon_dist_box.id = j_internet_szolg.dist_box_id
      INNER JOIN j_cim_osszerendelo ON j_cim_osszerendelo.id=j_internet_szolg.cim_osszerendelo_id
      INNER JOIN j_cim_telepules ON j_cim_telepules.id=j_cim_osszerendelo.telepules_id
      INNER JOIN j_cim_kozter_nevek ON j_cim_kozter_nevek.id=j_cim_osszerendelo.kozter_id
      INNER JOIN j_cim_kozter_jellegek ON j_cim_kozter_jellegek.id=j_cim_osszerendelo.kozter_jelleg_id
      WHERE j_szolg_tipus.nev = 'Gpon'
      AND j_dm_gpon_onu.gpon_serial <> 'N/A'
      AND j_status.nev IN ('aktív','tartozik','szünetel','kikapcsolva','megszünt','behajtásra kijelölve','behajtónak átadva')`;

    queryBySn = `(SELECT
    j_szolg.id AS "szolg_id",
    j_ugyfel.id AS "ugyfel_id",
    j_ugyfel.nev AS "ugyfel_nev",
    j_cim_telepules.irsz AS "irsz",
    j_cim_telepules.nev AS "telepulesnev",
    j_cim_telepules.varosresz AS "varosresz",
    j_cim_kozter_nevek.nev AS "kozternev",
    j_cim_kozter_jellegek.nev AS "kozterjelleg",
    j_internet_szolg.hsz AS "hazszam",
    j_internet_szolg.hsz2 AS "hazszam2",
    j_internet_szolg.gps_eszak AS "szolg_gps_latitude",
    j_internet_szolg.gps_kelet AS "szolg_gps_longitude",
    '0' AS "dist_box",
    j_device.serial_number AS "gpon_serial"
    FROM j_device
    INNER JOIN j_device_status_entry ON j_device.id = j_device_status_entry.device_id
    INNER JOIN j_device_status ON j_device_status_entry.status_id = j_device_status.id
    INNER JOIN j_device_on_service ON j_device_status_entry.id = j_device_on_service.status_entry_id
    INNER JOIN j_szolg ON j_device_on_service.service_id = j_szolg.id
    INNER JOIN j_ugyfel ON j_szolg.ugyfel_id = j_ugyfel.id
    INNER JOIN j_internet_szolg ON j_szolg.internet_szolg_id = j_internet_szolg.id
    INNER JOIN j_cim_osszerendelo ON j_cim_osszerendelo.id=j_internet_szolg.cim_osszerendelo_id
    INNER JOIN j_cim_telepules ON j_cim_telepules.id=j_cim_osszerendelo.telepules_id
    INNER JOIN j_cim_kozter_nevek ON j_cim_kozter_nevek.id=j_cim_osszerendelo.kozter_id
    INNER JOIN j_cim_kozter_jellegek ON j_cim_kozter_jellegek.id=j_cim_osszerendelo.kozter_jelleg_id
    WHERE j_device.serial_number IN (SELECT * FROM GPON_Serial) AND j_device_status.name = 'szolgáltatásnál'
    Order by j_device_status_entry.id DESC
    Limit 1)
    UNION
    (SELECT
    0 AS "szolg_id",
    0 AS "ugyfel_id",
    j_ap_station.nev AS "ugyfel_nev",
    j_cim_telepules.irsz AS "irsz",
    j_cim_telepules.nev AS "telepulesnev",
    j_cim_telepules.varosresz AS "varosresz",
    j_cim_kozter_nevek.nev AS "kozternev",
    j_cim_kozter_jellegek.nev AS "kozterjelleg",
    j_ap_station.house_number AS "hazszam",
    j_ap_station.house_number_ext AS "hazszam2",
    j_ap_station.gps_eszak AS "szolg_gps_latitude",
    j_ap_station.gps_kelet AS "szolg_gps_longitude",
    '0' AS "dist_box",
    j_device.serial_number AS "gpon_serial"
    FROM j_device
    INNER JOIN j_device_status_entry ON j_device.id = j_device_status_entry.device_id
    INNER JOIN j_device_status ON j_device_status_entry.status_id = j_device_status.id
    INNER JOIN j_device_on_base_station ON j_device_status_entry.id = j_device_on_base_station.status_entry_id
    INNER JOIN j_ap_station ON j_device_on_base_station.base_station_id = j_ap_station.id
    INNER JOIN j_cim_osszerendelo ON j_cim_osszerendelo.id=j_ap_station.address_id
    INNER JOIN j_cim_telepules ON j_cim_telepules.id=j_cim_osszerendelo.telepules_id
    INNER JOIN j_cim_kozter_nevek ON j_cim_kozter_nevek.id=j_cim_osszerendelo.kozter_id
    INNER JOIN j_cim_kozter_jellegek ON j_cim_kozter_jellegek.id=j_cim_osszerendelo.kozter_jelleg_id
    WHERE j_device.serial_number IN (SELECT * FROM GPON_Serial) AND j_device_status.name = 'bázisállomáson'
    Order by j_device_status_entry.id DESC
    Limit 1)
    UNION
    SELECT
    j_szolg.id AS "szolg_id",
    j_ugyfel.id AS "ugyfel_id",
    j_ugyfel.nev AS "ugyfel_nev",
    j_cim_telepules.irsz AS "irsz",
    j_cim_telepules.nev AS "telepulesnev",
    j_cim_telepules.varosresz AS "varosresz",
    j_cim_kozter_nevek.nev AS "kozternev",
    j_cim_kozter_jellegek.nev AS "kozterjelleg",
    j_internet_szolg.hsz AS "hazszam",
    j_internet_szolg.hsz2 AS "hazszam2",
    j_internet_szolg.gps_eszak AS "szolg_gps_latitude",
    j_internet_szolg.gps_kelet AS "szolg_gps_longitude",
    j_dm_gpon_dist_box.identifier AS "dist_box",
    j_dm_gpon_onu.gpon_serial AS "gpon_serial"
    FROM j_szolg
    INNER JOIN j_ugyfel ON j_ugyfel.id = j_szolg.ugyfel_id
    INNER JOIN j_internet_szolg ON j_internet_szolg.id = j_szolg.internet_szolg_id
    INNER JOIN j_szolg_csomag ON j_szolg_csomag.id = j_szolg.csomag_id
    INNER JOIN j_szolg_tipus ON j_szolg_tipus.id = j_szolg_csomag.tipus_id
    INNER JOIN j_status ON j_status.id = j_szolg.status_id
    INNER JOIN j_dm_gpon_onu ON j_dm_gpon_onu.id = j_internet_szolg.onu_id
    INNER JOIN j_dm_gpon_dist_box ON j_dm_gpon_dist_box.id = j_internet_szolg.dist_box_id
    INNER JOIN j_cim_osszerendelo ON j_cim_osszerendelo.id=j_internet_szolg.cim_osszerendelo_id
    INNER JOIN j_cim_telepules ON j_cim_telepules.id=j_cim_osszerendelo.telepules_id
    INNER JOIN j_cim_kozter_nevek ON j_cim_kozter_nevek.id=j_cim_osszerendelo.kozter_id
    INNER JOIN j_cim_kozter_jellegek ON j_cim_kozter_jellegek.id=j_cim_osszerendelo.kozter_jelleg_id
    WHERE j_szolg_tipus.nev = 'Gpon'
    AND j_dm_gpon_onu.gpon_serial <> 'N/A'
    AND j_status.nev IN ('aktív','tartozik','szünetel','kikapcsolva','megszünt','behajtásra kijelölve','behajtónak átadva')
    AND j_dm_gpon_onu.gpon_serial IN (SELECT * FROM GPON_Serial)
    `;

    onApplicationBootstrap() {
      this.dbConnect();
    }

    dbConnect() {
      if (process.env['GIGANET_CUSTOMER_DB_HOST']) {
        this.dbHost = process.env['GIGANET_CUSTOMER_DB_HOST'];
      }

      try {  
         this.pgClient.connectSync('postgresql://admin:admin@' + this.dbHost + ':5432/admin?connect_timeout=3');
  
         this.isConnected = true;
         Logger.log('PgService connected to database');

         // const rows = this.getCustomers('485754432C837166');
         // Logger.log(rows[0]);
         
         Logger.log(this.getDBStatus());
      } catch (error) {
        Logger.error('Postgres connect: ' + error, '', 'PgService');
      }              
    }

    @Cron(CronExpression.EVERY_10_SECONDS)
    reConnect () {
      if(!this.isConnected) {
        Logger.log('Try reconnect to DB...', 'PgService::Cron')
        this.dbConnect();
      }
    }
    
    getDBStatus(): CustomerDBStatus {
        try {
          this.custNum = this.getCustomers().length;
        } catch (err) {
          Logger.error(err);
          this.isConnected = false;
        } finally {
          return {
            status: this.isConnected,
            provider: 'giganet',
            title: 'Giganet',
            description: 'Giganet ügyfelek',
            customerNum: this.custNum,
            ontNum: this.custNum
          }
        }
    }
    
    getCustomers(sn: string = ''): GiganetCustomerData[] {
      try {
        if(sn.length) {
          const prefix = 'WITH GPON_Serial AS (VALUES(\'' + sn.toUpperCase() + '\')) ';
          return this.pgClient.querySync(prefix + this.queryBySn);
        }
        else {
          return this.pgClient.querySync(this.queryAll);
        }
      } catch (err) {
        this.isConnected = false;
        throw err;
      }
    }
}
